import { FlexDiv } from 'components/molecules/utils/basicComponents';
import { Typography } from 'foundations/typography';
import React from 'react';
import styled, { css } from 'styled-components';
import useTheme from 'hooks/useTheme';
import { getAmbienceColorId } from 'components/community/common/utils';

export const TimeZone = ({
    formData,
    showSidemenu,
    setShowSideMenu,
    selectedOption,
    newOnBoardingFlow = false,
    timeZone,
}) => {
    const { theme } = useTheme();
    const getColorId = (colorId) =>
        getAmbienceColorId({ colorId, isAgnostic: newOnBoardingFlow, theme });
    return (
        <>
            <FlexDiv>
                <Label htmlFor={'timeZonePicker'}>
                    <Typography
                        mb={'4px'}
                        variant={'subtext1'}
                        color={'ambience.1'}
                    >
                        Time zone
                    </Typography>

                    <SubLabel
                        mb={'0px'}
                        variant={'caption'}
                        color={'ambience.14'}
                    >
                        Event time zone
                    </SubLabel>
                </Label>
            </FlexDiv>
            <TimeZoneBox
                onClick={() => setShowSideMenu('timezone')}
                id={'timeZonePicker'}
                className={showSidemenu === 'timezone' && 'active'}
                showSidemenu={showSidemenu !== ''}
                mb={3}
                ambienceColorId={getColorId}
                newOnBoardingFlow={newOnBoardingFlow}
            >
                {selectedOption.length !== 0 && (
                    <Typography
                        variant={'subtext1'}
                        color={'ambience.0'}
                        mr={3}
                    >
                        {`UTC ${selectedOption.offset}`}
                    </Typography>
                )}
                <Typography variant={'caption'} color={'ambience.6'}>
                    {selectedOption.length !== 0
                        ? `${selectedOption.value.replace(/_/g, ' ')}`
                        : timeZone
                        ? timeZone.replace(/_/g, ' ')
                        : timeZone}
                </Typography>
            </TimeZoneBox>
        </>
    );
};

const Label = styled.label``;
const SubLabel = styled(Typography)`
    font-family: ${({ theme }) => theme.fonts.book};
`;
const TimeZoneBox = styled(FlexDiv)`
    position: relative;
    padding: 16px;
    cursor: pointer;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.ambience[20]};
    min-height: 55px;
    align-items: center;
    ${({ theme, showSidemenu, ambienceColorId }) =>
        showSidemenu &&
        `
    &::before{
        content: '';
        position: absolute;
        top: 50%;
        right: -70px;
        opacity: 0;
        height: 48px;
        width: 48px;
        transform: translate(400px,-50%) rotate(45deg);
        border-radius: 4px;
        background-color: ${theme.colors.ambience[ambienceColorId(2)]};
        z-index: 0;
        transition: all 0.35s ease-in-out;
    }
    &.active::before {
        opacity:1;
        transform: translate(0px,-50%) rotate(45deg);
    }
    `};
    background-color: ${({ theme, isLightBg }) =>
        isLightBg ? theme.colors.ambience[3] : theme.colors.ambience[20]};
    ${({ newOnBoardingFlow }) =>
        newOnBoardingFlow &&
        css`
            background-color: ${({ theme }) =>
                theme.colors.ambience[24]} !important;
            border: ${({ theme }) =>
                `1px solid ${theme.colors.ambience[20]} !important`};
        `}
`;
